// Client Cache & Snapshot Management (SWR)

export interface DashboardCache<T> {
  data: T;
  savedAt: number; // timestamp in ms when server responded
  formattedTime: string; // e.g. "14:32"
}

const CACHE_KEY = 'daily_sales_manager_snapshot_v1';
const STALE_THRESHOLD_MS = 2 * 60 * 1000; // 2 minutes

export function saveSnapshot<T>(data: T): DashboardCache<T> {
  const now = Date.now();
  const timeStr = new Date(now).toLocaleTimeString('th-TH', { hour: '2-digit', minute: '2-digit' });
  const cacheObj: DashboardCache<T> = {
    data,
    savedAt: now,
    formattedTime: timeStr
  };

  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(cacheObj));
  } catch (err) {
    console.warn('Failed to save snapshot to localStorage', err);
  }

  return cacheObj;
}

export function loadSnapshot<T>(): DashboardCache<T> | null {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as DashboardCache<T>;
  } catch {
    return null;
  }
}

export function isSnapshotStale(savedAt: number): boolean {
  return Date.now() - savedAt > STALE_THRESHOLD_MS;
}

export function formatLastUpdated(timeStr?: string): string {
  if (!timeStr) return 'ยังไม่อัปเดต';
  return `อัปเดต · ล่าสุด ${timeStr}`;
}
